import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as GreenPlusICon } from '../../../../assets/images/GreenPlusIcon.svg';
import EditIcon from '../../../../assets/svgComponents/EditIcon';
import PublicIcon from '../../../../assets/svgComponents/PublicIcon';
import QuillEditor from '../../../../components/shared/QuillEditor/QuillEditor';
import Tooltip from '../../../../components/shared/Tooltip/Tooltip';

import AboutModal from './AboutModal';

import styles from './About.module.scss';

const customModules = {
  toolbar: false,
};

const About = ({ bio, handleProfileUpdate, isPublic }) => {
  const { t } = useTranslation('common');
  const [showModal, setShowModal] = useState(false);

  const openModal = useCallback(() => {
    setShowModal(true);
  }, [setShowModal]);

  const closeModal = useCallback(() => {
    setShowModal(false);
  }, [setShowModal]);

  const handleSave = useCallback(
    (value) => {
      handleProfileUpdate({ bio: value }, closeModal);
    },
    [closeModal]
  );

  return (
    (!isPublic || bio) && (
      <div className={styles.container}>
        <AboutModal showModal={showModal} setShowModal={setShowModal} handleSave={handleSave} bio={bio} />
        <div className={styles.headerCont}>
          <div className={styles.headingCont}>
            <p className={styles.heading}>{t('account.about')}</p>
            {!isPublic && (
              <Tooltip text={t('profile.sectionIsPublic')}>
                <div className={styles.iconCont}>
                  <PublicIcon />
                </div>
              </Tooltip>
            )}
          </div>
          {!isPublic && !!bio && (
            <div onClick={openModal} role="presentation" className={styles.editIconCont}>
              <EditIcon />
            </div>
          )}
        </div>
        <div className={styles.content}>
          {bio ? (
            <QuillEditor value={bio} modules={customModules} disabled readOnly />
          ) : (
            !isPublic && (
              <button type="button" className={styles.addAbout} onClick={openModal}>
                <GreenPlusICon /> {t('profile.addAboutInfo')}
              </button>
            )
          )}
        </div>
      </div>
    )
  );
};

export default About;
